module.exports = __webpack_public_path__ + "img/canbadge-round-44mm-momo.d69cbac1.png";